import clsx from 'clsx';
import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { InsightCategoryType, InsightGroup } from '@/queries/insights';
import { GoToCallbackType, SortedTermsType } from '@/hooks/use-insights';

type Props = {
    basePath: string;
    group: InsightGroup;
    goTo: GoToCallbackType;
    terms?: InsightCategoryType[];
    sortedTerms: SortedTermsType;
};

export function Terms({ terms = [], sortedTerms, group, basePath, goTo }: Props) {
    if (!terms?.length) {
        return null;
    }

    const colors = [
        'r-bg-primary',
        'r-bg-primary-600',
        'r-bg-primary-300',
        'r-bg-primary-500',
        'r-bg-primary-400',
        'r-bg-primary-300',
        'r-bg-primary',
        'r-bg-primary-600',
        'r-bg-primary-300',
        'r-bg-primary-500',
        'r-bg-primary-400',
        'r-bg-primary-300',
        'r-bg-primary',
        'r-bg-primary-600',
        'r-bg-primary-300',
        'r-bg-primary-500',
        'r-bg-primary-400',
        'r-bg-primary-300',
    ];

    const colorfullTerms = useMemo(() => {
        const t = sortedTerms[group] || [];

        return [...t]
            .map((term, i) => {
                const index = i <= colors.length ? i : i - colors.length;

                return {
                    ...term,
                    color: colors[index],
                };
            })
            .filter(colorfulTerm => !!terms.find(term => term.id === colorfulTerm.id));
    }, [sortedTerms, group, terms]);

    return (
        <div data-component="terms" className="r-flex r-flex-wrap r-gap-2">
            {colorfullTerms.map(({ id, slug, title, color }) => (
                <Link
                    key={id}
                    className={clsx(color, 'r-rounded-xl r-p-2 r-text-xs r-font-bold r-text-white')}
                    to={`${basePath}/${slug}`}
                    onClick={e => {
                        e.preventDefault();
                        goTo('term', slug);
                    }}
                >
                    {title}
                </Link>
            ))}
        </div>
    );
}
